import React from 'react';
import APITokenManager from '@/Domains/API/APITokenManager';
import AppLayout from '@/Layouts/AppLayout';

export default function ApiTokenIndex({
  tokens,
  availablePermissions,
  defaultPermissions,
}) {
  return (
    <AppLayout title={'API Tokens'}>
        <div>
          <APITokenManager
            tokens={tokens}
            availablePermissions={availablePermissions}
            defaultPermissions={defaultPermissions}
          />
        </div>
    </AppLayout>
  );
}